import { FunctionComponent } from "react";
import { UserLocationControl } from "./UserLocationControl";
import { ZoomControl } from "./ZoomControl";
import { LayerControl } from "./LayerControl";

import "./MapControls.css";
import { useWindowSize } from "@hooks/useWindowSize/useWindowSize";

const MapControls: FunctionComponent = () => {
  const { isMobile } = useWindowSize();

  return (
    <div className={`map-controls-component ${isMobile ? "mobile" : ""}`}>
      <LayerControl />
      {/* spacer for where street view google control will be placed, rendered via gmaps. See
      `GoogleMapOverrides.css` for positioning the Street View button. */}
      {!isMobile && <div className="dummy-spacer" />}
      <UserLocationControl />
      {!isMobile && <ZoomControl />}
    </div>
  );
};

export { MapControls };
